import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';

import useStyles from '~/domains/common/components/AlertCard/alertCard.styles';
import type { ContestInvite } from './types';

type ContestInviteCardExpirationInfoProps = {
  invite: ContestInvite;
};

function ContestInviteCardExpirationInfo({ invite }: ContestInviteCardExpirationInfoProps) {
  const { classes } = useStyles();
  const { t } = useTranslation('contest');

  const entryDeadline = invite.contest?.entryDeadline;

  if (!entryDeadline) {
    return null;
  }

  const deadline = typeof entryDeadline === 'string' ? new Date(entryDeadline) : entryDeadline;

  if (Number.isNaN(deadline.getTime())) {
    return null;
  }

  const now = new Date();
  const isExpired = deadline <= now;

  if (isExpired) {
    return (
      <Text variant="body-medium" fw={500}>
        <span className={classes.expiryTime}>
          {t('common.contestInviteCard.expirationInfo.expired')}
        </span>
      </Text>
    );
  }

  return (
    <Text variant="body-medium" fw={500}>
      <span className={classes.expiryPrefix}>
        {t('common.contestInviteCard.expirationInfo.title')}
      </span>
      <span className={classes.expiryTime}>
        {formatDistanceToNow(deadline, { addSuffix: true })}
      </span>
    </Text>
  );
}

export default ContestInviteCardExpirationInfo;
